/**
 * The product's name, as every screen shows it. One place, so the next rename
 * is one line. It had another name until 26 September 2026, and
 * test/brand.test.ts refuses that one anywhere a student could see it.
 *
 * The mail follows it: the sender is noreply@legalstudious.standinglawyers.com,
 * verified in Resend on 26 September 2026, and the help address printed in
 * every sign in code is help.legalstudious@gmail.com.
 */

export const BRAND_NAME = "Legal Studious";

/**
 * The product's new name, Hallquill (Mohit, 16 October 2026, PRD D17), set as
 * the approved prototype sets its wordmark: "Hall" in the text's colour,
 * "quill" in the grey beside it. Harvey's look draws it from day 32 (the
 * sidebar's Wordmark). BRAND_NAME above follows on day 85, with the page
 * titles, the mail, the certificates and the sender name.
 */
export const WORDMARK = { lead: "Hall", tail: "quill" } as const;

/** Where a student writes when something is wrong. Printed, never a mailto form. */
export const HELP_EMAIL = "help.legalstudious@gmail.com";
